/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsCompanyBrandingConfig } from './FxIdDomainSettingsCompanyBrandingConfig';
import {
    instanceOfFxIdDomainSettingsCompanyBrandingConfig,
    FxIdDomainSettingsCompanyBrandingConfigFromJSON,
    FxIdDomainSettingsCompanyBrandingConfigFromJSONTyped,
    FxIdDomainSettingsCompanyBrandingConfigToJSON,
} from './FxIdDomainSettingsCompanyBrandingConfig';

/**
 * @type FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBranding
 * Настройки брендинга компании
 * @export
 */
export type FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBranding = FxIdDomainSettingsCompanyBrandingConfig;

export function FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingFromJSON(json: any): FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBranding {
    return FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBranding {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsCompanyBrandingConfig(json)) {
        return FxIdDomainSettingsCompanyBrandingConfigFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingToJSON(json: any): any {
    return FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingToJSONTyped(json, false);
}

export function FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingToJSONTyped(value?: FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBranding | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsCompanyBrandingConfig(value)) {
        return FxIdDomainSettingsCompanyBrandingConfigToJSON(value as FxIdDomainSettingsCompanyBrandingConfig);
    }

    return {};
}

